import { render, staticRenderFns } from "./ServicesForm.vue?vue&type=template&id=d2fbb54e"
import script from "./ServicesForm.vue?vue&type=script&lang=js"
export * from "./ServicesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports